
<template>
  <div>
    <toolbar></toolbar>
  </div>
</template>

<script>

import Toolbar from '@/views/general/components/Toolbar.vue'


export default {
  name: 'Header',
  components: {
    Toolbar
  }
}
</script>
